module.exports = __webpack_public_path__ + "static/media/caret-down.7b7f2e22.svg";